import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  getValues,
  getValuesSuccess,
  getCardsValues,
  getCardsValuesSuccess,
  getValueById,
  getValueByIdSuccess,
} from './slice';
import { DashboardValue, Period, TransactionsType } from '../types';

export const getRandomInt = (min: number, max: number): number => {
  const minValue = Math.ceil(min);
  const maxValue = Math.floor(max);

  return Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
};

const date = new Date();

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const timesMock = [
  {
    name: '00:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '01:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '02:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '03:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '04:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '05:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '06:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '07:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '08:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '09:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '10:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '11:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '12:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '13:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '14:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '15:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '16:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '17:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '18:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '19:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '20:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '21:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '22:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '23:00',
    value: getRandomInt(1, 1000).toString(),
  },
  {
    name: '24:00',
    value: getRandomInt(1, 1000).toString(),
  },
];

const weekMock = [
  {
    name: 'Mon',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (7 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'Tue',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (6 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'Wed',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (5 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'The',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (4 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'Fri',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (3 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'Sat',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (2 - date.getDay())),
    ).toISOString(),
  },
  {
    name: 'Sun',
    value: getRandomInt(1, 1000).toString(),
    date: new Date(
      new Date().setDate(date.getDate() - (1 - date.getDay())),
    ).toISOString(),
  },
];

const dashboardValueMock: DashboardValue = {
  id: 'uuid-1',
  name: 'New payments',
  value: '2540',
  percent: '87',
  data: [],
};

const cardsMock: DashboardValue[] = [
  {
    id: 'a-uuid-1',
    name: 'New card orders',
    value: '598',
    percent: '87',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-2',
    name: 'Processed card orders',
    value: '187',
    percent: '18',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-3',
    name: 'Send cards',
    value: '580',
    percent: '5',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-4',
    name: 'Activated cards',
    value: '50',
    percent: '0.78',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-5',
    name: 'Blocked cards',
    value: '4',
    percent: '1.33',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-6',
    name: 'Cards with negative balance',
    value: '12',
    percent: '0.5',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
  {
    id: 'a-uuid-7',
    name: 'Total funds spent or withdrawn',
    percent: '8',
    value: '1.5',
    data: [
      {
        name: '00:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '06:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '12:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '18:00',
        value: getRandomInt(1, 1000).toString(),
      },
      {
        name: '24:00',
        value: getRandomInt(1, 1000).toString(),
      },
    ],
  },
];

const getMonthMock = () => {
  const year = date.getFullYear();
  const month = date.getMonth();

  const firstDate = new Date();
  const lastDate = new Date(year, month + 1, 0);

  firstDate.setDate(1);
  firstDate.setHours(0);
  firstDate.setMinutes(0);
  firstDate.setSeconds(0);
  firstDate.setMilliseconds(0);
  lastDate.setHours(23);
  lastDate.setMinutes(59);
  lastDate.setSeconds(59);

  const dateArrays: number[] = [];

  for (let i = firstDate.getTime(); i < lastDate.getTime(); i += 86400000) {
    dateArrays.push(i);
  }

  return dateArrays;
};

const getDashboardValue = (
  value: DashboardValue,
  period: Period,
  dates?: string[],
  transationsType?: TransactionsType,
): DashboardValue => {
  const nextValue = { ...value };

  let data: { name: string; value: string; percent?: string }[] = [];

  if (period === Period.TODAY || period === Period.YESTERDAY) {
    data = timesMock.map((item) => ({
      name: item.name,
      value: getRandomInt(1, 1000).toString(),
      percent: transationsType ? getRandomInt(1, 100).toString() : '',
    }));
  } else if (period === Period.WEEK) {
    data = weekMock.map((item) => ({
      name: item.name,
      value: getRandomInt(1, 1000).toString(),
      percent: transationsType ? getRandomInt(1, 100).toString() : '',
      date: item.date,
    }));
  } else if (period === Period.MONTH) {
    const dateArrays = getMonthMock();

    data = dateArrays.map((item) => {
      const itemDate = new Date(item);

      return {
        name: `${itemDate.getDate() < 10 ? '0' : ''}${itemDate.getDate()}.${
          itemDate.getMonth() + 1 < 10 ? '0' : ''
        }${itemDate.getMonth() + 1}`,
        value: getRandomInt(1, 1000).toString(),
        percent: transationsType ? getRandomInt(1, 100).toString() : '',
      };
    });
  } else if (period === Period.QUARTER) {
    const month = date.getMonth();

    let dateArrays: string[] = [];

    if (month === 0 || month === 1 || month === 2) {
      dateArrays = [months[9], months[10], months[11]];
    } else if (month === 3 || month === 4 || month === 5) {
      dateArrays = [months[0], months[1], months[2]];
    } else if (month === 6 || month === 7 || month === 8) {
      dateArrays = [months[3], months[4], months[5]];
    } else if (month === 9 || month === 10 || month === 11) {
      dateArrays = [months[6], months[7], months[8]];
    }

    data = dateArrays.map((item) => ({
      name: item,
      value: getRandomInt(1, 1000).toString(),
      percent: transationsType ? getRandomInt(1, 100).toString() : '',
    }));
  } else if (dates?.length) {
    const firstDate = new Date(dates[0]);
    const lastDate = new Date(dates[1]);

    firstDate.setDate(1);
    firstDate.setHours(0);
    firstDate.setMinutes(0);
    firstDate.setSeconds(0);
    firstDate.setMilliseconds(0);
    lastDate.setHours(23);
    lastDate.setMinutes(59);
    lastDate.setSeconds(59);

    const dateArrays: number[] = [];

    for (let i = firstDate.getTime(); i < lastDate.getTime(); i += 86400000) {
      dateArrays.push(i);
    }

    data = dateArrays.map((item) => {
      const itemDate = new Date(item);

      return {
        name: `${itemDate.getDate() < 10 ? '0' : ''}${itemDate.getDate()}.${
          itemDate.getMonth() + 1 < 10 ? '0' : ''
        }${itemDate.getMonth() + 1}`,
        value: getRandomInt(1, 1000).toString(),
        percent: transationsType ? getRandomInt(1, 100).toString() : '',
        date: new Date(item),
      };
    });
  }

  nextValue.data = data;

  return nextValue;
};

const getMock = (values: DashboardValue[]): DashboardValue[] => {
  const nextValues = values.map((item) => {
    const result = { ...item };

    result.value = getRandomInt(0, 10000).toString();

    if (result.percent) {
      result.percent = getRandomInt(0, 100).toString();
    }

    const dataValues = [];

    for (let i = 0; i <= 5; i += 1) {
      dataValues.push({ value: getRandomInt(1, 1000).toString() });
    }

    result.data = dataValues.map((dataItem) => ({
      name: dataItem.value,
      value: dataItem.value,
    }));

    return result;
  });

  return nextValues;
};

const dashboardMiddleware = createListenerMiddleware();

dashboardMiddleware.startListening({
  actionCreator: getValues,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(
        getValuesSuccess({
          cards: cardsMock,
        }),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

dashboardMiddleware.startListening({
  actionCreator: getCardsValues,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(getCardsValuesSuccess(getMock(cardsMock)));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

dashboardMiddleware.startListening({
  actionCreator: getValueById,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(
        getValueByIdSuccess(
          getDashboardValue(
            dashboardValueMock,
            action.payload.period as Period,
            action.payload.dates,
            action.payload.transactionsType,
          ),
        ),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

export default dashboardMiddleware;
